module.exports = __webpack_public_path__ + "img/H5697.4244509e.jpg";